(() => {
  const SELECTOR = '[data-cb-free-ship="pool"]';
  const STORAGE_KEY = 'cb_free_ship_pool_achieved';

  const CLASS_ACHIEVED = 'cb-free-ship--achieved';
  const CLASS_SINK = 'cb-free-ship--sink';

  function getStored() {
    const v = sessionStorage.getItem(STORAGE_KEY);
    if (v === null) return null;
    return v === '1';
  }

  function setStored(val) {
    sessionStorage.setItem(STORAGE_KEY, val ? '1' : '0');
  }

  function applyState(el) {
    const achieved = el.getAttribute('data-achieved') === 'true';
    const stored = getStored();

    // First time we see it this session: set baseline, do not animate
    if (stored === null) {
      setStored(achieved);
      el.classList.toggle(CLASS_ACHIEVED, achieved);
      el.classList.remove(CLASS_SINK);
      return;
    }

    // Transition: not achieved -> achieved (animate once)
    if (achieved && stored === false) {
      el.classList.remove(CLASS_ACHIEVED);
      el.classList.add(CLASS_SINK);

      const onEnd = (e) => {
        if (e.animationName !== 'cbEightSink') return;
        el.removeEventListener('animationend', onEnd);
        el.classList.remove(CLASS_SINK);
        el.classList.add(CLASS_ACHIEVED);
      };

      el.addEventListener('animationend', onEnd);

      // Fallback in case the animation end event doesn't fire
      window.setTimeout(() => {
        el.classList.remove(CLASS_SINK);
        el.classList.add(CLASS_ACHIEVED);
      }, 800);

      setStored(true);
      return;
    }

    // Reset: achieved -> not achieved
    if (!achieved && stored === true) {
      el.classList.remove(CLASS_SINK);
      el.classList.remove(CLASS_ACHIEVED);
      setStored(false);
      return;
    }

    // Steady states
    el.classList.toggle(CLASS_ACHIEVED, achieved);
    el.classList.remove(CLASS_SINK);
  }

  function init(el) {
    if (el.__cbPoolInit) return;
    el.__cbPoolInit = true;

    applyState(el);

    // If Horizon morphs/updates attributes on the same node
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'data-achieved') {
          applyState(el);
        }
      }
    });
    mo.observe(el, { attributes: true });
  }

  function scan(root = document) {
    root.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // Catch cart drawer re-renders (new nodes inserted)
  const bodyMo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(SELECTOR)) init(node);
        node.querySelectorAll?.(SELECTOR).forEach(init);
      }
    }
  });
  bodyMo.observe(document.documentElement, { subtree: true, childList: true });
})();
